// extracted by mini-css-extract-plugin
export default {"descriptions":"InvoiceDownloadDialog_descriptions__pMk0k","checbox_group":"InvoiceDownloadDialog_checbox_group__7Isxb","functions":"InvoiceDownloadDialog_functions__mKNF+"};